import HttpRequest from './axios'
const axios = new HttpRequest()
export default axios


// WEBPACK FOOTER //
// ./src/libs/api.request.js